import DataObject from '../../../common/model/DataObject';

export default class DataChannel extends DataObject {
  getPropertyNames() {
    return [
      'identifier',
      'dataShareRatio',
    ];
  }
}